import currency from "currency.js";
import React, { useState, useEffect, useMemo } from "react";
import Badge from 'react-bootstrap/Badge';
import Modal from 'react-bootstrap/Modal';
import Spinner from 'react-bootstrap/Spinner';
import moment from 'moment';
import AlertConfirmModal from "../../common/AlertConfirmModal";
import PAlert from "../../common/PAlert";
import { s3Link, supportLink } from '../../utils/constants';
import CloseButton from '../../common/CloseButton';
import { useToasts } from 'react-toast-notifications';
import { connect } from 'react-redux';

import './mediastats.scss';
import { captureException } from '@sentry/react';
import Caption from '../../common/Caption';
import useDidMountEffect from '../../utils/useDidMountEffect';
import copy from 'copy-to-clipboard';
import styled from 'styled-components';

const ClickableArea = styled.div`
    display: inline;
    cursor: pointer;
    padding: 10px;
    position: absolute;
    left: 0;
    bottom: -1px;
    z-index: 1;
`;

const SpinnerContainer = styled.div`
    padding: 10px;
    display: block;
    text-align: center
`;

const MediaPrice = ({
    media,
    su,
    broadcastModal,
    stashSidebar,
    conversation,
    setActiveStashItem,
    setDeletedMessagePrice
}) => {
    const { addToast } = useToasts();

    const [show, setShow] = useState(false);
    const [mediaStats, setMediaStats] = useState([]);
    const [isBusy, setIsBusy] = useState(false);
    const [statsListInfoModalIsOpen, setStatsListInfoModalIsOpen] = useState(false);
    const [hasMore, setHasMore] = useState(true);
    const [totalMediaStat, setTotalMediaStat] = useState(0);
    const [statsListMedia, setStatsListMedia] = useState([]);
    const [statsListMediaModalIsOpen, setStatsListMediaModalIsOpen] = useState(false);
    const [showAlert, setShowAlert] = useState(false);
    const [alertTitle, setAlertTitle] = useState(false);
    const [alertBody, setAlertBody] = useState('');
    const [rerender, setRerender] = useState(1);

    const handleHideModal = () => {
        setShow(false);
        setIsBusy(false);
    };

    useDidMountEffect(() => {
        setActiveStashItem(media);
        setRerender(rerender => rerender += 1);
    }, [media]);

    const getMessages = async () => {
        setIsBusy(true);
        setShow(true);
        await axios.get(`/api/messages/media-statistics/${media.media_id}`, {
            params: {
                stats_loaded: totalMediaStat,
                sidebar: broadcastModal || stashSidebar,
                conversation
            }
        })
            .then(response => {
                if (totalMediaStat === 0) {
                    setMediaStats(response.data);
                } else {
                    setMediaStats([...mediaStats, ...response.data]);
                }

                setTotalMediaStat(totalMediaStat => totalMediaStat + response.data.length);

                if (response.data.length < 5) {
                    setHasMore(false);
                }

                setIsBusy(false);
                setShow(true);

            })
            .catch(error => {
                setIsBusy(false);
                console.log({ error });
            });
        // }
    };

    const [activeMedia, setActiveMedia] = useState({});
    const [showConfirm, setshowConfirm] = useState(false);

    useEffect(() => {
        if (activeMedia && Object.keys(activeMedia).length > 0) {
            setshowConfirm(true);
        }
    }, [activeMedia]);

    useEffect(() => {
        if (!showConfirm) {
            setActiveMedia({});
        }
    }, [showConfirm]);

    const renderTypeLabel = (broadcast) => {
        if (broadcast) {
            switch (broadcast.type) {
                case 0:
                    return 'All Subscribers';
                case 1:
                    return 'New Subscribers';
                case 2:
                    return 'Subscriber Range';
                case 3:
                    return 'Unsubscribed';
                case 4:
                    return 'Favourites';
                case 5:
                    return 'Re-send';
                case 6:
                    return 'Online';
                case 7:
                    return 'User Lists';
                default:
                    return 'Broadcast Message';
            }
        }

        return 'Broadcast Message';
    };

    const renderTypeDataLabel = (broadcast) => {
        if (broadcast) {
            if ([0, 2, 5].includes(broadcast.type)) { // new subscribers
                return 'RANGE';
            }

            if (broadcast.type == 1) { // new subscribers
                return 'PAST HOURS, NEW SUBS';
            }

            if (broadcast.type == 7) { // new subscribers
                return 'USER LISTS';
            }
        }
    };

    const renderTypeData = (stat) => {
        if ([0, 5].includes(stat.broadcast.type)) {
            return stat.broadcast.type_data
                ? `${stat.broadcast.type_data.range_id_from} - ${stat.broadcast.type_data.range_id_to}`
                : '';
        }

        if (stat.broadcast.type == 1) { // new subscribers
            return `Past ${stat.broadcast.type_data.new_subs_pastHours} hours, ${stat.broadcast.type_data.new_subs_limit} subs, range ${stat.broadcast.type_data.range_id_from} - ${stat.broadcast.type_data.range_id_to}`;
        }

        if (stat.broadcast.type == 2) { // Range
            const from = moment(stat.broadcast.type_data.range_date_from);
            const to = moment(stat.broadcast.type_data.range_date_to);

            let range = '';

            // same month and year
            if (from.format('MMMM') == to.format('MMMM') && from.format('YYYY') == to.format('YYYY')) {
                range = `${from.format('D')} - ${to.format('D MMM YYYY')}`;
            }

            if (from.format('MM') != to.format('MM') && from.format('YYYY') == to.format('YYYY')) {
                range = `${from.format('D MMM')} - ${to.format('D MMM YYYY')}`;
            }

            if (from.format('YYYY') != to.format('YYYY')) {
                range = `${from.format('D MMM YYYY')} - ${to.format('D MMM YYYY')}`;
            }

            range += `<br />${stat.broadcast.type_data.range_id_from} - ${stat.broadcast.type_data.range_id_to}`;

            return range;
        }

        if (stat.broadcast.type == 7) { // user lists
            return stat.broadcast.type_data && stat.broadcast.type_data.userlist_names
                ? stat.broadcast.type_data.userlist_names.join(', ')
                : null;
        }
    };

    const handleStatsListInfoModal = () => {
        setStatsListInfoModalIsOpen(false);
    };

    const showStatsInfoModal = () => {
        setStatsListInfoModalIsOpen(true);
    };

    const removeMessage = () => {
        axios.delete(`/api/messages/all/${activeMessage.id}`, {
            data: {
                media_id: media.media_id,
                source: 'message'
            }
        })
            .then((response) => {
                window.dispatchEvent(new Event('chatmessage/loadMessages'));
                getMessages();
                setAlertBody(`Unpaid message${activeMessage.broadcast_id > 0 ? 's' : ''} removed.`);
                setShowAlert(true);

                setDeletedMessagePrice(response.data.latest);

                const index = mediaStats.findIndex(stat => stat.id === activeMessage.id);
                if (index >= 0) {
                    mediaStats.splice(index, 1);
                }

                window.dispatchEvent(new Event('chatmessage/fetchConvs'));
            })
            .catch((error) => {
                if (error.response && error.response.status === 405) {
                    setAlertBody('Unable to remove paid PPV');
                    setShowAlert(true);
                } else {
                    captureException(error);
                }
            });
    };

    const fetchMessageMedia = (messageId, type) => {
        axios.get('/api/messages/medias', {
            params: {
                message_id: messageId,
                type
            }
        })
            .then((response) => {
                setStatsListMedia(response.data);
                setStatsListMediaModalIsOpen(true);
            })
            .catch((error) => {
                captureException(error);
            });
    };

    const handleStatsListMediaModal = () => {
        setStatsListMediaModalIsOpen(false);
    };

    const handleCopy = (caption) => {
        copy(caption, {
            debug: false,
            message: 'Click to copy caption'
        });

        addToast('Caption successfully copied', { appearance: 'success', autoDismiss: true });
    };

    const Price = ({ media }) => {
        if (media.latest_price !== null) {
            if (media.latest_price > 0) {
                return <span>{currency(media.latest_price).format({ precision: 2 })}</span>;
            } else {
                return <span>FREE</span>;
            }
        }

        return '';
    };

    const RenderBadge = ({ media }) => {
        return <ClickableArea
            onClick={getMessages}
        >
            <Badge
                bg="secondary"
                className={`media-price${isBusy ? ' disable-link' : ''}`}
            >
                {
                    <Price media={media} />
                } <i className="far fa-info-circle" style={{ color: '#fff', fontWeight: '500' }}></i>
            </Badge>
        </ClickableArea>;
    };

    const [confirmBody, setConfirmBody] = useState('');
    const [activeMessage, setActiveMessage] = useState({});
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const handleConfirm = (message) => {
        const confirmMessage = message.broadcast_id <= 0
            ? `Remove this PPV sent to ${message.reciever.login}?`
            : 'Remove for all subscribers (Paid PPVs are not removed)?';

        setActiveMessage(message);
        setConfirmBody(confirmMessage);
        setShowConfirmModal(true);
    };

    const [isBundle, setIsBundle] = useState(false);
    useDidMountEffect(() => {
        if (mediaStats.length > 0) {
            const totalMedia = parseInt(mediaStats[0].total_images) + parseInt(mediaStats[0].total_videos);
            setIsBundle(totalMedia > 1);
        }
    }, [mediaStats]);

    return <React.Fragment>
        {rerender > 0 && <RenderBadge media={media} />}
        {show && <Modal
            show={show}
            onHide={handleHideModal}
            className="media-stats-modal media-stats-not-sold"
            centered
            size="md"
        >
            <Modal.Header>
                <Modal.Title>
                    <CloseButton
                        className="close"
                        style={{ position: 'absolute', right: 12, top: 5 }}
                        onClick={handleHideModal}
                    />
                    {
                        `Last sent PPV media ${isBundle ? 'in a bundle' : ''} for ${media.latest_price > 0 ? currency(media.latest_price).format({ precision: 2 }) : 'free'}`
                    }
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>

                {
                    !isBusy && mediaStats && mediaStats.length <= 0 && <SpinnerContainer>
                        No Media information found.
                    </SpinnerContainer>
                }
                {
                    mediaStats && mediaStats.length > 0 && mediaStats.map((mediaStat, index) => {
                        return <div className="stats-list-cont" key={`${mediaStat.id}-${index}`}>
                            <div className={`stats-item`}>
                                <div className="stats-item-row">
                                    <div className="stats-item-lbl">
                                        DATE & TIME
                                    </div>
                                    <div className="stats-item-value">
                                        {
                                            moment.utc(mediaStat.created_at).local().format('LLL')
                                        }
                                    </div>
                                </div>
                                <div className="stats-item-row">
                                    <div className="stats-item-lbl">
                                        MESSAGE TYPE
                                    </div>
                                    <div className="stats-item-value">
                                        {
                                            mediaStat.broadcast_id > 0 ? renderTypeLabel(mediaStat.broadcast) : 'Individual Message'
                                        }
                                    </div>
                                </div>


                                {
                                    renderTypeDataLabel(mediaStat.broadcast) && <div className="stats-item-row">
                                        <div className="stats-item-lbl">
                                            {
                                                renderTypeDataLabel(mediaStat.broadcast)
                                            }
                                        </div>
                                        <div className="stats-item-value">
                                            <span dangerouslySetInnerHTML={{ __html: renderTypeData(mediaStat) }} />
                                        </div>
                                    </div>
                                }


                                {mediaStat.message && mediaStat.message.length > 0 && <div className="stats-item-row">
                                    <div className="stats-item-lbl stats-item-lbl-caption">
                                        CAPTION <span style={{ fontSize: '12px', color: '#0097fe', cursor: 'pointer' }} onClick={() => handleCopy(mediaStat.message)} title="Click to copy caption"><i className="fa-sharp fa-regular fa-copy"></i></span>
                                    </div>
                                    <div className={`stats-item-value stats-item-value-caption text-right`}>
                                        <Caption content={mediaStat.message} />
                                    </div>
                                </div>}


                                {(mediaStat.total_images > 0 || mediaStat.total_videos > 0) && <div className="stats-item-row">
                                    <div className="stats-item-lbl">
                                        # MEDIA
                                    </div>
                                    <div className="stats-item-value stats-item-value-media">
                                        {
                                            mediaStat.total_images > 0 && <span style={{ color: '#0097fe' }} onClick={() => { fetchMessageMedia(mediaStat.id, 'image'); }}>
                                                <img src="https://privaposts.com/img-icon-dark.png?v=2" alt="image" /><b> {mediaStat.total_images}</b>
                                            </span>
                                        }
                                        {
                                            mediaStat.total_videos > 0 && <span style={{ color: '#0097fe' }} onClick={() => { fetchMessageMedia(mediaStat.id, 'video'); }}>
                                                <img src="https://privaposts.com/vid-icon-dark.png?v=2" alt="video" className="stats-vid-icon" />
                                                <b> {mediaStat.total_videos}</b>
                                            </span>
                                        }
                                    </div>
                                </div>
                                }


                                <div className="stats-item-row">
                                    <div className="stats-item-lbl">
                                        PRICE
                                    </div>
                                    <div className="stats-item-value">
                                        {
                                            mediaStat.price > 0 ? currency(mediaStat.price).format({ precision: 2 }) : '$'
                                        }
                                    </div>
                                </div>

                                <div className="stats-item-row">
                                    <div className="stats-item-lbl">
                                        SENT
                                    </div>
                                    <div className="stats-item-value">
                                        {mediaStat.sent}
                                    </div>
                                </div>
                                <div className="stats-item-row">
                                    <div className="stats-item-lbl">
                                        VIEWED
                                    </div>
                                    <div className="stats-item-value">
                                        {mediaStat.read}
                                    </div>
                                </div>
                                <div className="stats-item-row">
                                    <div className="stats-item-lbl">
                                        PURCHASED
                                    </div>
                                    <div className="stats-item-value">
                                        {mediaStat.paid}
                                    </div>
                                </div>

                                <div className="stats-item-row stats-item-row-delete">
                                    <div className="stats-item-lbl">
                                        REMOVE UNPAID MESSAGES <i className="far fa-info-circle" style={{ color: '#0097fe', fontWeight: '500', cursor: 'pointer' }} onClick={() => showStatsInfoModal()}></i>
                                    </div>
                                    <div className="stats-item-value stats-item-value-remove-msg">
                                        <span
                                            className="remove-mass-message"
                                            style={{ color: '#0097fe', fontWeight: 'bolder', textDecoration: 'none' }}
                                            onClick={() => { handleConfirm(mediaStat); }}
                                        >Remove</span>
                                    </div>
                                </div>
                            </div>
                        </div>;
                    })
                }

                {
                    isBusy && <SpinnerContainer>
                        <Spinner size="sm" variant='primary' animation='border' /><br />Checking record
                    </SpinnerContainer>
                }

                <div className="stats-list-load-more">
                    {
                        !isBusy && hasMore && <span
                            className="stats-load-more-btn"
                            onClick={getMessages}
                        >Load More</span>
                    }
                </div>
            </Modal.Body>
        </Modal>}

        {statsListInfoModalIsOpen && <Modal
            show={statsListInfoModalIsOpen}
            onHide={handleStatsListInfoModal}
            className="stats-info-modal"
            centered
            size="md"
            style={{ zIndex: 2147488 }}
        >
            <Modal.Title style={{ minHeight: 'unset', padding: '12px' }}>
                <CloseButton className="close" onClick={handleStatsListInfoModal} style={{ position: 'absolute', top: '12px', right: '12px' }} />
                Remove for all subscribers (Paid PPVs are not removed)
            </Modal.Title>
        </Modal>}

        {statsListMediaModalIsOpen && <Modal
            show={statsListMediaModalIsOpen}
            onHide={handleStatsListMediaModal}
            className="blockuser-modal media-list-modal"
            centered
            size="md"
            style={{ zIndex: 2147489 }}
        >
            <Modal.Header>
                <Modal.Title>Media Attachments</Modal.Title>
                <CloseButton className="close" style={{ position: 'absolute', right: '12px' }} onClick={handleStatsListMediaModal} />
            </Modal.Header>
            <Modal.Body>
                <div className="media-attachment-container stash-cont">
                    {
                        statsListMedia && statsListMedia.map((k, index) => (
                            <div className="stash-item" key={index}>
                                <div
                                    className="stash-item-img"
                                    href="#"
                                    style={{ backgroundImage: `url('${s3Link}/${k.thumb_path}')` }}
                                ></div>
                            </div>
                        ))
                    }
                </div>
            </Modal.Body>
        </Modal>}

        {showAlert && <PAlert
            show={showAlert}
            setShow={setShowAlert}
            title={alertTitle}
            body={alertBody}
            bodyStyle={{ textAlign: 'center' }}
            footerStyle={{ display: 'block', textAlign: 'center' }}
        />}

        {showConfirmModal && <AlertConfirmModal
            modalBody={`${confirmBody}`}
            show={showConfirmModal}
            setShow={setShowConfirmModal}
            useFunction={removeMessage}
            isConfirm
        />}
    </React.Fragment>;
};

const mapStateToProps = (state) => {
    return {
        broadcastModal: state.message.broadcastModal,
        stashSidebar: state.stash.stashSidebar,
        conversation: state.message.activeConv,
    };
};


export default connect(mapStateToProps)(React.memo(MediaPrice));
